// Client-side mirror of the BFF's validation (parsina.bff.crm leadIntake.js),
// so the visitor gets an instant, field-level message in Persian instead of a
// round trip. The BFF re-validates everything — this file is UX, not defense.

const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹';
const ARABIC_DIGITS = '٠١٢٣٤٥٦٧٨٩';

export function asciiDigits(value) {
  let out = '';
  for (const ch of String(value || '')) {
    const p = PERSIAN_DIGITS.indexOf(ch);
    const a = ARABIC_DIGITS.indexOf(ch);
    out += p >= 0 ? String(p) : a >= 0 ? String(a) : ch;
  }
  return out;
}

export function normalizeIranMobile(value) {
  const digits = asciiDigits(value).replace(/[\s\-().]/g, '');
  const m = digits.match(/^(?:\+98|0098|98|0)?(9\d{9})$/);
  return m ? `0${m[1]}` : null;
}

// → { errors: {field: message}, ok: boolean }
export function validateLeadForm({ firstName, lastName, mobile, consent }) {
  const errors = {};
  if (!String(firstName || '').trim()) errors.firstName = 'لطفاً نام را وارد کنید.';
  if (!String(lastName || '').trim()) errors.lastName = 'لطفاً نام خانوادگی را وارد کنید.';
  if (!normalizeIranMobile(mobile)) {
    errors.mobile = 'شماره موبایل معتبر نیست. نمونه: ۰۹۱۲۳۴۵۶۷۸۹';
  }
  if (consent !== true) {
    errors.consent = 'برای تماس کارشناسان پارسینا، ثبت رضایت لازم است.';
  }
  return { errors, ok: Object.keys(errors).length === 0 };
}
